export default "__VITE_ASSET__BH$ZKpxa__"